<div class="address-container">
  <div class="asset-network-pair mb-20">
    <bp-select
      (selectedValueChange)="onCoinChange($event)"
      [(selectedValue)]="field._cryptocoin_id"
      [bindLabel]="'name'"
      [label]="'asset' | translate"
      [options]="coinOptions"
      [customSearchFn]="getCustomSearch()"
      [searchable]="true"
      class="contact-edit-select mr-10 full-border">
    </bp-select>
    <bp-select
      (selectedValueChange)="onNetorwkChange($event)"
      [(selectedValue)]="field._coin_network_id"
      [bindLabel]="'name'"
      [label]="'network' | translate"
      [options]="networkOptions$ | async"
      [searchable]="true"
      class="contact-edit-select full-border">
    </bp-select>
  </div>
  <div class="mb-20">
    <bp-input
      (onKeyEnter)="saveContact()"
      [(value)]="field.value"
      [error]="field.getValidationError('value') | translate"
      [formGroupClass]="false"
      [label]="'wallet_addresses' | translate"
      [placeholder]="'enter_an_address' | translate"
    [type]="'text'"></bp-input>
  </div>
  @if (destinationTagType$ | async; as destinationTagType) {
    <div class="mb-20">
      @if (destinationTagType) {
        <bp-input (onKeyEnter)="saveContact()"
          [(value)]="field.destination_tag"
          [error]="field.getValidationError('destination_tag') | translate"
          [formGroupClass]="false"
          [label]="'placeholder_destination_tag' | translate: [destinationTagType | translate | capitalize]"
          [placeholder]="destinationTagType | translate | capitalize"
        [type]="'text'"></bp-input>
      }
    </div>
  }
  <div>
    <div class="remove-input">
      <bp-input
        (onKeyEnter)="saveContact()"
        [(value)]="field.name"
        [error]="field.getValidationError('name') | translate"
        [formGroupClass]="false"
        [label]="'custom_title_optional' | translate"
        [maxlength]="40"
        [placeholder]="'label_for_contact_address_title' | translate"
        [type]="'text'"
        class="custom-title-input">
      </bp-input>
      <div class="remove" right>
        <a (click)="deleteAddress()" [tabIndex]="0" class="font-size-20">
          <span class="bpi__icon-minus-round"></span>
        </a>
      </div>
    </div>
  </div>
</div>